import { Component, HostListener } from '@angular/core';
// import { MatSnackBar } from '@angular/material/snack-bar';
import { Observable, fromEvent } from 'rxjs';
import { Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
declare var $:JQueryStatic;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'GstInUI';

  onlineEvent: Observable<Event>;
  offlineEvent: Observable<Event>;

  subscriptions: Subscription[] = [];

  connectionStatusMessage: string = '';
  connectionStatus: string = '';

  constructor(private toastr: ToastrService) {
    this.onlineEvent = fromEvent(window, 'online');
    this.offlineEvent = fromEvent(window, 'offline');

    this.subscriptions.push(this.onlineEvent.subscribe(e => {
      this.connectionStatusMessage = 'Back to online.';
      this.connectionStatus = 'online';
      $('html, body').css('pointer-events', '');
      // this.snackBarService.openSnackBar(this.connectionStatusMessage,'close','info-snackbar','Info');
      this.toastr.info(this.connectionStatusMessage,null,{
        positionClass : "toast-top-right"
      });
      // this.snackBar.open(this.connectionStatusMessage,'close',{
      //   horizontalPosition: "right",
      //   verticalPosition: "top",
      //   duration: 3000,
      //   panelClass: ['info-snackbar']
      // }); 

    }));
  
    this.subscriptions.push(this.offlineEvent.subscribe(e => {
      this.connectionStatusMessage = 'Connection lost! You are not connected to internet.';
      this.connectionStatus = 'offline';
      $('html, body').css('pointer-events', 'none');
      this.toastr.info(this.connectionStatusMessage,null,{
        positionClass : "toast-top-right"
      });
      // this.snackBar.open(this.connectionStatusMessage,'close',{
      //   horizontalPosition: "right",
      //   verticalPosition: "top",
      //   duration: 3000,
      //   panelClass: ['warning-snackbar'],
      // }); 
    }));
  }
      
  ngOnDestroy(){
	  this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

}
